import { Button } from '@/components/ui/Button'
import { EXIT, stepCount, tourName } from './tourText'

interface TourPanelChipProps {
  title: string
  step: number
  total: number
  onExit: () => void
}

/**
 * The Help & feedback panel folded while a tour it started plays (spec §4): the tour's name,
 * "2 of 5" and Exit, at the panel's edge. The panel comes back as it was when the tour ends.
 */
export function TourPanelChip({ title, step, total, onExit }: TourPanelChipProps) {
  return (
    <div
      role="group"
      aria-label={tourName(title)}
      data-testid="tour-panel-chip"
      className="pointer-events-auto fixed right-4 bottom-4 flex items-center gap-3 rounded-full border border-border bg-popover py-1.5 pr-1.5 pl-4 text-sm text-popover-foreground shadow-lg"
    >
      <span className="font-medium">{tourName(title)}</span>
      <span className="text-muted-foreground">{stepCount(step, total)}</span>
      <Button variant="ghost" size="sm" onClick={onExit}>
        {EXIT}
      </Button>
    </div>
  )
}
